import { Box, Divider, Typography } from '@mui/material';
import React, { useState } from 'react';
import {
  createDocuments,
  getApplicationByApplicationId,
  getDocumentByDocId,
} from '../../Utils/apiServices';

import { makeStyles } from '@mui/styles';
import { saveAs } from 'file-saver';
import { useSnackbar } from 'notistack';
import { useEffect } from 'react';
import KenStepperFooter from '../KenApplicationForm/Components/KenStepperFooter/index';
import KenDialog from '../KenDialog';
import KenDocumentUpload from '../KenDocumentUpload';
import FilePreview from '../KenDocumentUpload/Components/KenFilePreview';
import KenLoader from '../KenLoader';

const useStyles = makeStyles(() => ({
  title: {
    color: '#092682',
    fontWeight: 600,
    textAlign: 'left',
    marginBottom: 32,
    fontSize: 20,
  },
}));

export default function DocumentUpload(props) {
  const styles = useStyles();
  const { applicationState, applicationDispatch } = props;
  // const [appState, setAppState] = useState([applicationState]);
  const [url, setUrl] = useState();
  const [filePreview, setFilePreview] = useState(false);
  const [pageLoader, setPageLoader] = useState(false);
  const [file, setFile] = useState();
  const [trigger, setTrigger] = useState(false);
  const [uploadData, setUploadData] = useState([
    {
      title: 'Pitch Deck',
      description: 'Max file size limit- 5MB. (only PDF accepted)',
      previewImage: null,
      required: true,
    },
  ]);
  // const {
  //   state: { user },
  // } = useContext(AuthContext);
  const { enqueueSnackbar } = useSnackbar();
  console.log(applicationState);

  useEffect(() => {
    if (applicationState?.applicationData?.attachments) {
      const uploadDataCopy = [...uploadData];
      applicationState?.applicationData?.attachments?.forEach((el) => {
        let index = uploadDataCopy.findIndex((elem) => elem.title === el.title);
        console.log(index);
        if (index > -1) {
          uploadDataCopy[index] = { ...uploadDataCopy[index], ...el };
        }
      });
      setUploadData([...uploadDataCopy]);
      setPageLoader(false);
    }
  }, [trigger]);

  const convertBase64ToFile = (base64String, fileName, fileType) => {
    // let arr = base64String.split(',');
    let mime = fileType;
    let bstr = atob(base64String);
    let n = bstr.length;
    let uint8Array = new Uint8Array(n);
    while (n--) {
      uint8Array[n] = bstr.charCodeAt(n);
    }
    let file = new File([uint8Array], fileName, { type: fileType });
    return file;
  };

  const getData = () => {
    setPageLoader(true);
    getApplicationByApplicationId(
      applicationState?.applicationData?.application?.recordId
    )
      .then((resp) => {
        if (resp?.success && resp?.data) {
          const uploadDataCopy = [...uploadData];
          resp?.data?.attachments?.forEach((el) => {
            let index = uploadDataCopy.findIndex(
              (elem) => elem.title === el.title
            );
            if (index > -1) {
              uploadDataCopy[index] = { ...uploadDataCopy[index], ...el };
            }
          });
          setUploadData([...uploadDataCopy]);
          setPageLoader(false);
        }
      })
      .catch((err) => {
        console.log(err);
        setPageLoader(false);
      });
  };

  useEffect(() => {
    if (!(file instanceof File)) {
      setUrl(file);
    }
  }, [file]);

  // useEffect(() => {
  //   getData();
  // }, []);

  const onError = (err) => console.log('Error:', err);

  const handlePrev = () => {
    applicationDispatch({ type: 'prevStep' });
  };
  const handleNext = () => {
    // if (uploadData.every((e) => e?.recordId)) {
    applicationDispatch({ type: 'nextStep' });
    // } else {
    //   return enqueueSnackbar('Upload all documents', {
    //     variant: 'info',
    //   });
    // }
  };

  const handleDownload = (id, fileType, fileName) => {
    setPageLoader(true);
    getDocumentByDocId(id)
      .then((res) => {
        if (res?.success && res?.data) {
          // setFilePreview(true);
          // setFile(`data:${fileType};base64,${res?.data}`);
          setPageLoader(false);
          let file = convertBase64ToFile(res?.data, fileName, fileType);
          saveAs(file, fileName);
        }
      })
      .catch((err) => {
        console.log(err);
        setPageLoader(false);
      });
  };

  const uploadDoc = (file, el) => {
    setPageLoader(true);
    const reader = new FileReader();
    let base64;
    reader.onloadend = () => {
      base64 = reader.result.replace('data:', '').replace(/^.+,/, '');
      const body = {
        fileName: file?.name,
        title: el.title,
        expiryDate: null,
        body: base64,
        applicationId: applicationState?.applicationId,
        fileType: file.type,
      };
      createDocuments({
        attachments: [body],
        application: { ...applicationState?.applicationData?.application },
      })
        .then((res) => {
          setPageLoader(false);
          if (res?.success === true) {
            applicationDispatch({
              type: 'update',
              payload: { applicationData: res?.data },
            });
            setTrigger(!trigger)
            return enqueueSnackbar('Document Uploaded Successfully', {
              variant: 'success',
            });
          }
        })
        .catch((err) => {
          setPageLoader(false);
          console.log('error', err);
          return enqueueSnackbar(
            'Error while uploading. Please try again later.',
            {
              variant: 'error',
            }
          );
        });
    };
    reader.readAsDataURL(file);
  };

  return (
    <React.Fragment>
      <Box
        sx={{
          width: '50vw',
          margin: '30px auto 0px auto',
          paddingBottom: '32px',
        }}
      >
        <Typography className={styles.title}>Document Upload</Typography>
        {uploadData?.map((el) => {
          return (
            <>
              {pageLoader && <KenLoader />}
              <KenDocumentUpload
                label={el.title}
                handleDownload={handleDownload}
                onChange={(file) => uploadDoc(file[0], el)}
                {...el}
              />

              <Divider
                variant="fullWidth"
                style={{ background: '#E2E2E2', marginBottom: '30px' }}
              />
            </>
          );
        })}
      </Box>
      <KenDialog
        open={filePreview}
        handleClose={() => {
          setFilePreview(false);
        }}
      >
        <FilePreview
          type={'file'}
          file={file instanceof File && file}
          onError={onError}
          width={'210px'}
          height={'150px'}
          // removeFile={removeFile}
          url={url}
        />
      </KenDialog>

      <KenStepperFooter
        totalSteps={applicationState.totalSteps}
        activeStep={applicationState.activeStep}
        onPrev={handlePrev}
        onNext={handleNext}
        applicationStatus={
          applicationState?.applicationData?.application?.applicationStatus
        }
      />
    </React.Fragment>
  );
}
